import React from "react";
import { defineMessages } from "react-intl";
import { renderChip } from "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { withDataGridEntityClient, withDataGridEntityServer } from "../../../components/data-grid/mui/DataGridEntity.js";
import { MuiDataGridClient } from "../../../components/data-grid/mui/MuiDataGridClient.js";
import { MuiDataGridServer } from "../../../components/data-grid/mui/MuiDataGridServer.js";
import { DataGridEntityConfigFactory } from "../../../components/data-grid/mui/types.js";
import { renderCurrencyCellWithEmptyCheck, Currency } from "../../../components/data-grid/mui/cells/CurrencyCell.js";
import { renderDateCell } from "../../../components/data-grid/mui/cells/DateCell.js";
import { renderCellWithTooltip } from "../../../components/data-grid/mui/cells/GridCellWithTooltip.js";
import { renderLabelsCell, labelCellValueGetter } from "../../../components/data-grid/mui/cells/LabelsCell.js";
import { renderGridNumber } from "../../../components/data-grid/mui/cells/NumberCell.js";
import { renderCellHeader, renderMuiGridLocalizedTextCell } from "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import { renderDefaultChipCell } from "../../../components/data-grid/mui/cells/ChipCell.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import { renderPercentCell } from "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import { TransactionStatus } from "../../../contract/pam.js";
import { licenseLocalized } from "../../brand-license/constants.js";
import "@automapper/core";
import "../../../auto-mapper/AutoMapperProvider.js";
import "typesafe-actions";
import "rxjs";
import "redux-observable";
import "../../../api/types.js";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "react-oidc-context";
import "oidc-client-ts";
import "../../brand-license/components/LicenseSelect.js";
import "../../brand-license/components/BrandSelect.js";
import { BrandCircle } from "../../brand-license/components/BrandCircle.js";
import { transactionActions } from "../actions.js";
import { TransactionTypeTypeName } from "../constants.js";
import { renderTransactionDuration } from "./DurationCell.js";
import { renderTransactionMethod } from "./MethodCell.js";
import { renderActionConfirmationButtonWithInProgressCheck } from "./RetryActionButtonCell.js";
import { renderTransactionStatus } from "./StatusCell.js";
import { renderP2PTransferDirection } from "./TypeCell.js";
const localized = defineMessages({
  uid: {
    id: "DataGridTransaction_Uid",
    defaultMessage: "User ID"
  },
  transaction_id: {
    id: "DataGridTransaction_TransactionId",
    defaultMessage: "Transaction ID"
  },
  type: {
    id: "DataGridTransaction_Direction",
    defaultMessage: "Direction"
  },
  amount: {
    id: "DataGridTransaction_Amount",
    defaultMessage: "Amount"
  },
  timestamp: {
    id: "DataGridTransaction_Timestamp",
    defaultMessage: "Timestamp"
  },
  transaction_type: {
    id: "DataGridTransaction_TransactionType",
    defaultMessage: "Type"
  },
  payment_method_name: {
    id: "DataGridTransaction_PaymentMethod",
    defaultMessage: "Method"
  },
  payment_method_description: {
    id: "DataGridTransaction_PaymentMethodDescription",
    defaultMessage: "Reference"
  },
  currency: {
    id: "DataGridTransaction_Currency",
    defaultMessage: "Currency"
  },
  transaction_status: {
    id: "DataGridTransaction_TransactionStatus",
    defaultMessage: "Status"
  },
  current_balance: {
    id: "DataGridTransaction_CurrentBalance",
    defaultMessage: "Balance"
  },
  current_casino_coin_balance: {
    id: "DataGridTransaction_CurrentCasinoCoinBalance",
    defaultMessage: "Casino Coin Balance"
  },
  withdrawal_id: {
    id: "DataGridTransaction_WithdrawalId",
    defaultMessage: "Withdrawal ID"
  },
  email: {
    id: "DataGridTransaction_Email",
    defaultMessage: "Email Address"
  },
  duration: {
    id: "DataGridTransaction_Duration",
    defaultMessage: "Duration"
  },
  p2p_direction: {
    id: "DataGridTransaction_P2PDirection",
    defaultMessage: "Direction"
  },
  phone: {
    id: "DataGridTransaction_Phone",
    defaultMessage: "Phone number"
  },
  username: {
    id: "DataGridTransaction_Username",
    defaultMessage: "Username"
  },
  register_marketing_code: {
    id: "DataGridTransaction_MarketingCode",
    defaultMessage: "Marketing Code"
  },
  referrer_player_id: {
    id: "DataGridTransaction_ReferrerPlayerId",
    defaultMessage: "Referral ID"
  },
  player_country: {
    id: "DataGridTransaction_Country",
    defaultMessage: "Country"
  },
  counterpart_player_id: {
    id: "DataGridTransaction_CounterpartPlayerId",
    defaultMessage: "Counterpart player ID"
  },
  user_labels: {
    id: "DataGridTransaction_userLabels",
    defaultMessage: "Label"
  },
  id: {
    id: "DataGridTransaction_id",
    defaultMessage: "ID"
  },
  status_log: {
    id: "DataGridTransaction_status_log",
    defaultMessage: "Status Log"
  },
  assignee: {
    id: "DataGridTransaction_assignee",
    defaultMessage: "Assignee"
  },
  last_reason: {
    id: "DataGridTransaction_last_reason",
    defaultMessage: "Last Reason"
  },
  retries: {
    id: "DataGridTransaction_retries",
    defaultMessage: "Retries"
  },
  retry_handled_at: {
    id: "DataGridTransaction_retry_handled_at",
    defaultMessage: "Handling Time"
  },
  product_type: {
    id: "DataGridTransaction_product_type",
    defaultMessage: "Product Type"
  },
  created_by_uid: {
    id: "DataGridTransaction_createdByUid",
    defaultMessage: "Created By"
  },
  error_code: {
    id: "DataGridTransaction_errorCode",
    defaultMessage: "Error Code"
  },
  error_json: {
    id: "DataGridTransaction_errorJson",
    defaultMessage: "Error Json"
  },
  turnover_rate: {
    id: "DataGridTransaction_turnoverRate",
    defaultMessage: "Turnover Rate"
  },
  withdrawable_balance: {
    id: "DataGridTransaction_withdrawableBalance",
    defaultMessage: "Withdrawable Balance"
  },
  transfer_amount: {
    id: "DataGridTransaction_transferAmount",
    defaultMessage: "Transfer Amount"
  },
  valid_bet: {
    id: "DataGridTransaction_validBet",
    defaultMessage: "Valid Bet"
  },
  ptp_counterparty_uid: {
    id: "DataGridTransaction_ptpCounterpartyUid",
    defaultMessage: "Counterparty UID"
  },
  retryButtonLabel: {
    id: "DataGridTransaction_retryButtonLabel",
    defaultMessage: "Re-Try"
  },
  retryModalTitle: {
    id: "DataGridTransaction_retryModalTitle",
    defaultMessage: "Re-try Transaction"
  },
  retryModalDescription: {
    id: "DataGridTransaction_retryModalDescription",
    defaultMessage: "Are you sure you want to proceed the transaction with amount {amount} to player {player_id}?"
  },
  deleteButtonLabel: {
    id: "DataGridTransaction_deleteButtonLabel",
    defaultMessage: "Delete"
  },
  deleteModalTitle: {
    id: "DataGridTransaction_deleteModalTitle",
    defaultMessage: "Delete Transaction"
  },
  deleteModalDescription: {
    id: "DataGridTransaction_deleteModalDescription",
    defaultMessage: "Are you sure you want to delete the transaction with amount {amount} to player {player_id}?"
  },
  cancelButtonLabel: {
    id: "DataGridTransaction_cancelButtonLabel",
    defaultMessage: "Cancel"
  },
  proceedButtonLabel: {
    id: "DataGridTransaction_proceedButtonLabel",
    defaultMessage: "Proceed"
  },
  licenseTypeLabel: {
    id: "DataGridTransaction_licenseTypeLabel",
    defaultMessage: "License Type"
  },
  brandLabel: {
    id: "DataGridTransaction_brandLabel",
    defaultMessage: "Brand"
  }
});
const localizedTransactionDataGridHeaders = {
  uid: localized.uid,
  transaction_id: localized.transaction_id,
  type: localized.type,
  amount: localized.amount,
  amount_without_currency: localized.amount,
  transaction_started_ts: localized.timestamp,
  transaction_updated_ts: localized.timestamp,
  transaction_type: localized.transaction_type,
  payment_method_name: localized.payment_method_name,
  payment_method_description: localized.payment_method_description,
  currency: localized.currency,
  transaction_status: localized.transaction_status,
  current_balance: localized.current_balance,
  current_casino_coin_balance: localized.current_casino_coin_balance,
  withdrawal_id: localized.withdrawal_id,
  email: localized.email,
  duration: localized.duration,
  p2p_direction: localized.p2p_direction,
  phone: localized.phone,
  username: localized.username,
  register_marketing_code: localized.register_marketing_code,
  referrer_player_id: localized.referrer_player_id,
  player_country: localized.player_country,
  counterpart_player_id: localized.counterpart_player_id,
  user_labels: localized.user_labels,
  id: localized.id,
  status_log: localized.status_log,
  assignee: localized.assignee,
  last_reason: localized.last_reason,
  retries: localized.retries,
  retry_handled_at: localized.retry_handled_at,
  product_type: localized.product_type,
  created_by_uid: localized.created_by_uid,
  error_code: localized.error_code,
  error_json: localized.error_json,
  turnover_rate: localized.turnover_rate,
  // Assuming turnover_rate is represented as an amount
  withdrawable_balance: localized.withdrawable_balance,
  transfer_amount: localized.transfer_amount,
  valid_bet: localized.valid_bet,
  ptp_counterparty_uid: localized.ptp_counterparty_uid,
  license_type: localized.licenseTypeLabel,
  brand: localized.brandLabel
};
class DataGridTransactionConfigFactory extends DataGridEntityConfigFactory {
  getColumnConfig() {
    const columnsMapping = {
      brand: {
        field: "brand",
        valueGetter: (_, row) => this.getBrand(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.brand,
        renderCell: (params) => /* @__PURE__ */ React.createElement(BrandCircle, { value: params.value }),
        sortable: false,
        flex: 0.15,
        width: 100
      },
      license_type: {
        field: "license_type",
        valueGetter: (_, row) => this.getLicenseType(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.license_type,
        renderCell: renderMuiGridLocalizedTextCell,
        sortable: true,
        flex: 0.1,
        width: 100
      },
      uid: {
        field: "uid",
        valueGetter: (_, row) => this.getUid(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.uid,
        renderCell: renderDefaultChipCell,
        flex: 0.15,
        width: 100,
        sortable: false
      },
      transaction_id: {
        field: "transaction_id",
        valueGetter: (_, row) => this.getTransactionId(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.transaction_id,
        renderCell: renderDefaultChipCell,
        flex: 0.15,
        width: 150,
        sortable: false
      },
      transaction_started_ts: {
        field: "transaction_started_ts",
        valueGetter: (_, row) => this.getTransactionStartedTs(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.transaction_started_ts,
        renderCell: renderDateCell,
        flex: 0.175,
        width: 175,
        sortable: false
      },
      transaction_updated_ts: {
        field: "transaction_updated_ts",
        valueGetter: (_, row) => this.getTransactionUpdatedTs(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.transaction_updated_ts,
        renderCell: (p) => typeof p.row.transaction_updated_ts === "string" ? renderCellWithTooltip(p) : renderDateCell(p),
        flex: 0.175,
        width: 175,
        sortable: false
      },
      type: {
        field: "type",
        valueGetter: (_, row) => this.getType(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.type,
        renderCell: (params) => renderChip(params.value, TransactionTypeTypeName),
        flex: 0.2,
        width: 200,
        sortable: false
      },
      transaction_type: {
        field: "transaction_type",
        valueGetter: (_, row) => this.getType(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.transaction_type,
        renderCell: (params) => !params.row.is_summary ? renderChip(params.value, TransactionTypeTypeName) : null,
        flex: 0.15,
        width: 150,
        sortable: false
      },
      payment_method_name: {
        field: "payment_method_name",
        valueGetter: (_, row) => this.getPaymentMethodName(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.payment_method_name,
        renderCell: (p) => !p.row.is_summary ? renderTransactionMethod(p) : null,
        flex: 0.15,
        width: 150,
        sortable: false
      },
      payment_method_description: {
        field: "payment_method_description",
        valueGetter: (_, row) => this.getPaymentMethodDescription(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.payment_method_description,
        renderCell: (p) => !p.row.is_summary ? renderCellWithTooltip(p) : null,
        flex: 0.2,
        width: 200,
        sortable: false
      },
      amount: {
        field: "amount",
        valueGetter: (_, row) => this.getAmount(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.amount,
        renderCell: renderCurrencyCellWithEmptyCheck,
        flex: 0.15,
        width: 150,
        sortable: false
      },
      amount_without_currency: {
        field: "amount_without_currency",
        valueGetter: (_, row) => this.getAmountWithoutCurrency(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.amount_without_currency,
        renderCell: renderGridNumber,
        flex: 0.11,
        width: 110,
        sortable: false
      },
      transfer_amount: {
        field: "transfer_amount",
        valueGetter: (_, row) => this.getAmount(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.transfer_amount,
        renderCell: renderCurrencyCellWithEmptyCheck,
        flex: 0.15,
        width: 150,
        sortable: false
      },
      withdrawable_balance: {
        field: "withdrawable_balance",
        valueGetter: (_, row) => this.getWithdrawableBalance(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.withdrawable_balance,
        renderCell: renderCurrencyCellWithEmptyCheck,
        flex: 0.15,
        width: 150,
        sortable: true
      },
      currency: {
        field: "currency",
        valueGetter: (_, row) => this.getCurrency(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.currency,
        renderCell: (p) => !p.row.is_summary ? renderCellWithTooltip(p) : null,
        flex: 0.12,
        width: 120,
        sortable: false
      },
      transaction_status: {
        field: "transaction_status",
        valueGetter: (_, row) => this.getTransactionStatus(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.transaction_status,
        renderCell: (params) => !params.row.is_summary ? renderTransactionStatus(params) : null,
        flex: 0.3,
        width: 300,
        sortable: false
      },
      current_balance: {
        field: "current_balance",
        valueGetter: (_, row) => this.getCurrentBalance(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.current_balance,
        renderCell: (p) => !p.row.is_summary ? renderCurrencyCellWithEmptyCheck(p) : null,
        flex: 0.12,
        width: 120,
        sortable: false
      },
      current_casino_coin_balance: {
        field: "current_casino_coin_balance",
        valueGetter: (_, row) => this.getCurrentCasinoCoinBalance(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.current_casino_coin_balance,
        renderCell: (p) => !p.row.is_summary ? renderCurrencyCellWithEmptyCheck(p) : null,
        flex: 0.12,
        width: 120,
        sortable: false
      },
      email: {
        field: "email",
        valueGetter: (_, row) => this.getEmail(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.email,
        renderCell: renderCellWithTooltip,
        flex: 0.2,
        width: 200,
        sortable: false
      },
      phone: {
        field: "phone",
        valueGetter: (_, row) => this.getPhone(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.phone,
        renderCell: renderCellWithTooltip,
        flex: 0.15,
        width: 150,
        sortable: false
      },
      username: {
        field: "username",
        valueGetter: (_, row) => this.getUsername(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.username,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      register_marketing_code: {
        field: "register_marketing_code",
        valueGetter: (_, row) => this.getMarketingCode(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.register_marketing_code,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      referrer_player_id: {
        field: "referrer_player_id",
        valueGetter: (_, row) => this.getReferrerPlayerId(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.referrer_player_id,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      player_country: {
        field: "player_country",
        valueGetter: (_, row) => this.getPlayerCountry(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.player_country,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      counterpart_player_id: {
        field: "counterpart_player_id",
        valueGetter: (_, row) => this.getCounterpartPlayerId(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.counterpart_player_id,
        renderCell: renderCellWithTooltip,
        flex: 0.15,
        width: 150,
        sortable: false
      },
      duration: {
        field: "duration",
        valueGetter: (_, row) => this.getDuration(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.duration,
        renderCell: renderTransactionDuration,
        flex: 0.11,
        width: 110,
        sortable: false
      },
      user_labels: {
        field: "user_labels",
        valueGetter: (_, row) => this.getLabels(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.user_labels,
        renderCell: renderLabelsCell,
        flex: 0.2,
        width: 200,
        sortable: false
      },
      p2p_direction: {
        field: "p2p_direction",
        valueGetter: (_, row) => this.getType(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.p2p_direction,
        renderCell: renderP2PTransferDirection,
        flex: 0.15,
        width: 100,
        sortable: false
      },
      created_by_uid: {
        field: "created_by_uid",
        valueGetter: (_, row) => this.getCreatedByUid(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.created_by_uid,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      product_type: {
        field: "product_type",
        valueGetter: (_, row) => this.getProductType(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.product_type,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      turnover_rate: {
        field: "turnover_rate",
        valueGetter: (_, row) => this.getTurnoverRate(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.turnover_rate,
        renderCell: renderPercentCell,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      retry_handled_at: {
        field: "retry_handled_at",
        valueGetter: (_, row) => this.getHandlingTime(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.retry_handled_at,
        renderCell: renderDateCell,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      error_code: {
        field: "error_code",
        valueGetter: (_, row) => this.getErrorCode(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.error_code,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      error_json: {
        field: "error_json",
        valueGetter: (_, row) => this.getErrorJson(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.error_json,
        renderCell: renderCellWithTooltip,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      retry_action: {
        field: "retry_action",
        valueGetter: (_, row) => this.getRetryActionValue(row),
        headerName: " ",
        renderCell: renderActionConfirmationButtonWithInProgressCheck,
        flex: 0.15,
        width: 100,
        sortable: false
      },
      delete_action: {
        field: "delete_action",
        valueGetter: (_, row) => this.getDeleteActionValue(row),
        headerName: " ",
        renderCell: renderActionConfirmationButtonWithInProgressCheck,
        flex: 0.15,
        width: 100,
        sortable: false
      },
      valid_bet: {
        field: "valid_bet",
        valueGetter: (_, row) => this.getValidBet(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.valid_bet,
        renderCell: (p) => !p.row.is_summary ? renderCurrencyCellWithEmptyCheck(p) : null,
        flex: 0.1,
        width: 100,
        sortable: false
      },
      ptp_counterparty_uid: {
        field: "ptp_counterparty_uid",
        valueGetter: (_, row) => row?.ptp_counterparty_uid,
        renderHeader: renderCellHeader,
        localizedHeaderName: localizedTransactionDataGridHeaders.ptp_counterparty_uid,
        renderCell: (p) => !p.row.is_summary ? renderCellWithTooltip(p) : null,
        flex: 0.1,
        width: 150,
        sortable: false
      }
    };
    return columnsMapping;
  }
  getBrand(model) {
    return model?.brand;
  }
  getLicenseType(model) {
    return model?.license_type ? licenseLocalized[model?.license_type] : void 0;
  }
  getRetryActionValue(model) {
    return {
      label: localized.retryButtonLabel,
      modalTitle: localized.retryModalTitle,
      description: localized.retryModalDescription,
      descriptionValues: { player_id: model?.uid, amount: model?.amount?.toString() },
      confirmAction: transactionActions.retryTransaction,
      confirmActionPayload: model?.transaction_id,
      confirmButtonLabel: localized.proceedButtonLabel,
      cancelButtonLabel: localized.cancelButtonLabel,
      disabled: model?.transaction_status === TransactionStatus.InProgress
    };
  }
  getDeleteActionValue(model) {
    return {
      label: localized.deleteButtonLabel,
      modalTitle: localized.deleteModalTitle,
      description: localized.deleteModalDescription,
      descriptionValues: { player_id: model?.uid, amount: model?.amount?.toString() },
      confirmAction: transactionActions.deleteTransaction,
      confirmActionPayload: model?.transaction_id,
      confirmButtonLabel: localized.proceedButtonLabel,
      cancelButtonLabel: localized.cancelButtonLabel,
      disabled: model?.transaction_status === TransactionStatus.InProgress
    };
  }
  getUid(model) {
    return model?.uid;
  }
  getEmail(model) {
    return model?.email;
  }
  getTransactionId(model) {
    return model?.transaction_id;
  }
  getType(model) {
    return model?.transaction_type;
  }
  getAmount(model) {
    const value = { amount: this.getAmountWithoutCurrency(model), currency: this.getCurrency(model) };
    return value;
  }
  getAmountWithoutCurrency(model) {
    return model?.amount;
  }
  getWithdrawableBalance(model) {
    return { amount: model?.withdrawable_balance, currency: this.getCurrency(model) };
  }
  getCurrency(model) {
    return model?.currency;
  }
  getTransactionStartedTs(model) {
    return model?.transaction_started_ts;
  }
  getTransactionUpdatedTs(model) {
    return model?.transaction_updated_ts;
  }
  getPaymentMethodName(model) {
    return { payment_method_name: model?.payment_method_name, transaction_type: model?.transaction_type };
  }
  getPaymentMethodDescription(model) {
    return model?.payment_method_description;
  }
  getTransactionStatus(model) {
    return { status: model?.transaction_status, reason: model?.last_reason };
  }
  getCurrentBalance(model) {
    const value = { amount: model?.current_balance, currency: this.getCurrency(model) };
    return value;
  }
  getCurrentCasinoCoinBalance(model) {
    const value = { amount: model?.current_casino_coin_balance, currency: Currency.CasinoCoin };
    return value;
  }
  getDuration(model) {
    return { history: model?.status_log, started_at: model?.transaction_started_ts };
  }
  getPhone(model) {
    return model?.phone;
  }
  getUsername(model) {
    return model?.username;
  }
  getMarketingCode(model) {
    return model?.register_marketing_code;
  }
  getReferrerPlayerId(model) {
    return model?.referrer_player_id;
  }
  getPlayerCountry(model) {
    return model?.player_country;
  }
  getCounterpartPlayerId(model) {
    return model?.counterpart_player_id;
  }
  getLabels(model) {
    return labelCellValueGetter(model?.user_labels);
  }
  getCreatedByUid(model) {
    return model?.created_by_uid;
  }
  getProductType(model) {
    return model?.product_type;
  }
  getHandlingTime(model) {
    return model?.retry_handled_at;
  }
  getErrorCode(model) {
    let result = model?.error_code;
    try {
      result = JSON.stringify(JSON.parse(result), null, 2);
    } catch {
    }
    return result;
  }
  getErrorJson(model) {
    let result = model?.error_json;
    try {
      result = JSON.stringify(JSON.parse(result), null, 2);
    } catch {
    }
    return result;
  }
  getTurnoverRate(model) {
    return { value: model?.turnover_rate };
  }
  getValidBet(model) {
    return { amount: model?.valid_bet, currency: this.getCurrency(model) };
  }
}
const DataGridTransactionsClient = withDataGridEntityClient(
  MuiDataGridClient,
  () => ({ ...new DataGridTransactionConfigFactory().getColumnConfig() })
);
const DataGridTransactionsServer = withDataGridEntityServer(
  MuiDataGridServer,
  () => ({ ...new DataGridTransactionConfigFactory().getColumnConfig() })
);
export {
  DataGridTransactionConfigFactory,
  DataGridTransactionsClient,
  DataGridTransactionsServer,
  localizedTransactionDataGridHeaders
};
//# sourceMappingURL=DataGrid.js.map
